module.exports = __webpack_public_path__ + "static/img/section-3.b92c6b8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/weicai/aboutWe/section-3.png
// module id = zrAu
// module chunks = 3